<template>
  <nav class="site-nav--secondary">
    <ul v-for="section in Object.keys(routes)"
        :key="section"
        v-show="$root.currentSubMenu === section">
      <li class="list-heading">{{$t('nav.sections_heading')}}</li>
      <li v-for="route in routes[section]" :key="route">
        <router-link :to="{name: route, params: { lang: $route.params.lang }}">{{$t(`nav.${route}`)}}</router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'NavSecondary',
  props: {
    routes: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';

#app.submenu-opened {
  .site-nav--secondary {
    transform: translate($sidenav-width, 0);
  }
}

.site-nav--secondary {
  display: none;
  background: rgba(98, 100, 105, .95);
  padding-top: 118px; // Same as the header height + padding from the primary menu so the list headings line up
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  box-shadow: 1px 0px 10px -5px rgba(0, 0, 0, 0.25);
  @media(min-width: $screen-sm-min) {
    display: block;
  }
  ul {
    margin: 24px 0 0 0;
    padding: 0;
    list-style: none;
    margin-bottom: 0;
    > li {
      font-size: 13px;
      line-height: 21px;
      color: $white;
      padding: 14px 24px;
      margin-bottom: 0;
      font-weight: 500;
      &.list-heading {
        color: $grey;
        border-bottom: 1px solid rgba(250, 250, 250, .12);
        font-size: px2rem(10);
        text-transform: uppercase;
        margin: 16px 22px;

        padding: 0;
        padding-bottom: 5px;
      }

      a {
        color: inherit;
        text-decoration: none;
        display: block;
        @include activeLinkIndicator(-13px, 5px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavSecondary.vue